import { useRef } from "react";

/**
 * Custom hook to debounce a function.
 * @param {Function} func - The function to debounce.
 * @param {number} delay - The debounce delay in milliseconds.
 * @returns {Function} - The debounced function.
 */
const useDebounce = (func, delay) => {
  const timerRef = useRef(null);

  return function debouncedFunction(...args) {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export default useDebounce;